<template>
  <div style="height: 100%;flex-direction: column;display: flex;">
    <div v-if="showData.author_sim_count" style="display: flex;flex:1;height: 1px;position: relative;">
      <div style="flex:1;padding:0 15px;display: flex;flex-direction: column;width: 1px;">
        <div class="fileTitle">基准文件</div>
        <div
            style="display: flex;flex-direction: column;flex:1;height: 1px;border:1px solid #DCDFE6;margin-top: 16px;border-radius: 5px;">
          <div
              style="background: #E5E6EB;height: 40px;line-height: 40px;padding-left: 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight: bold;color: #000;">
            {{ showData.name }}/{{ showData.mulu }}
          </div>
          <div style="flex:1;height: 1px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <img src="@/assets/image/author.png" alt="" height="330px" width="330px">
            <div style="position: relative;top:-118px;height: 55px;line-height: 55px;font-weight: bold;font-size: 30px;margin-left: 10px;">    {{showData.author_sims.author}}</div>
            <div  style="position: relative;top:-80px;height: 30px;line-height: 30px;font-weight: bold;font-size: 20px;margin-left: 10px;">文件创建作者</div>
          </div>
        </div>
      </div>
      <div style="flex:1;padding:0 15px;display: flex;flex-direction: column;width: 1px;">
        <div class="fileTitle">目标文件</div>
        <div
            style="display: flex;flex-direction: column;flex:1;height: 1px;border:1px solid #DCDFE6;margin-top: 16px;border-radius: 5px;">
          <div
              style="background: #E5E6EB;height: 40px;line-height: 40px;padding-left: 20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight: bold;color: #000;">
            {{ showData.cont_name }}/{{ showData.cont_mulu }}
          </div>
          <div style="flex:1;height: 1px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <img src="@/assets/image/author.png" alt="" height="330px" width="330px">
            <div style="position: relative;top:-118px;height: 55px;line-height: 55px;font-weight: bold;font-size: 30px;margin-left: 10px;">    {{showData.author_sims.o_author}}</div>
            <div  style="position: relative;top:-80px;height: 30px;line-height: 30px;font-weight: bold;font-size: 20px;margin-left: 10px;">文件创建作者</div>
          </div>
        </div>
      </div>
      <div style="position:absolute;left: calc(50% - 150px);top:calc(50% - 85px);">
        <img src="@/assets/image/leitong.png" alt="" style="width: 300px;">
      </div>
    </div>
    <div v-else
         style="flex:1;height: 1px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
      <img alt="" src="@/assets/image/empty.png">
      <div style="margin-top: 10px;">无异常</div>
    </div>
  </div>

</template>

<script>
export default {
  name: "authorCmp",
  props: {
    contId: {
      type: String,
      required: true
    },
    baseId: {
      type: String,
      required: true
    },
    showData: {
      type: Object,
      required: true
    }
  },
}
</script>

<style scoped>

</style>
